import React from 'react';
import { motion } from 'framer-motion';
import { FiMail, FiMapPin } from 'react-icons/fi';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-slate-900/30">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">Let's Collaborate</h2>
          <p className="text-slate-400">Ready to bring your ideas to life? Get in touch.</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="grid sm:grid-cols-2 gap-6 max-w-2xl mx-auto"
        >
          <a
            href="mailto:dhaanu97@gmail.com"
            className="glass-card p-8 rounded-2xl flex flex-col items-center text-center gap-4 hover:border-indigo-500/50 transition-all hover:-translate-y-1 group"
          >
            <div className="p-4 bg-indigo-500/10 rounded-full text-indigo-400 group-hover:scale-110 transition-transform duration-300">
              <FiMail size={32} />
            </div>
            <div>
              <h3 className="text-white font-bold text-lg mb-1">Email Me</h3>
              <p className="text-slate-400">dhaanu97@gmail.com</p>
            </div>
          </a>

          <div className="glass-card p-8 rounded-2xl flex flex-col items-center text-center gap-4 hover:border-indigo-500/50 transition-all hover:-translate-y-1 group">
            <div className="p-4 bg-indigo-500/10 rounded-full text-indigo-400 group-hover:scale-110 transition-transform duration-300">
              <FiMapPin size={32} />
            </div>
            <div>
              <h3 className="text-white font-bold text-lg mb-1">Location</h3>
              <p className="text-slate-400">Chennai (Open to Bangalore & Remote as well)</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;